export const BusinessViewTypes = {
  REGULAR: 1,
  LINEAR: 2,
  FASHION: 3,
  MAGAZINE: 4,
}

export const BUSINESS_VIEWS = [
  {
    id: BusinessViewTypes.REGULAR,
    name: 'Regular',
    glyph: 'regular',
  },
  {
    id: BusinessViewTypes.LINEAR,
    name: 'Linear',
    glyph: 'linear',
  },
  {
    id: BusinessViewTypes.FASHION,
    name: 'Fashion',
    glyph: 'fashion',
  },
  {
    id: BusinessViewTypes.MAGAZINE,
    name: 'Magazine',
    glyph: 'magazine',
  },
]

export function businessViewById(viewType) {
  const id = Number(viewType)
  return BUSINESS_VIEWS.find((view) => view.id === id) || BUSINESS_VIEWS[0]
}
